/* ==============================================================================
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
============================================================================== */

// prop-types is a library for typechecking of props
import PropTypes from 'prop-types';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDAvatar from 'components/MDAvatar';

function ProductCell({ image, name, orders }) {
  return (
    <MDBox display='flex' alignItems='center' pr={2}>
      <MDBox mr={2}>
        <MDAvatar src={image} alt={name} variant='rounded' />
      </MDBox>
      <MDBox display='flex' flexDirection='column'>
        <MDTypography variant='button' fontWeight='medium'>
          {name}
        </MDTypography>
        <MDTypography variant='button' fontWeight='regular' color='secondary'>
          <MDTypography component='span' variant='button' fontWeight='regular' color='secondary'>
            {orders}
          </MDTypography>
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}

// Typechecking props for the ProductCell
ProductCell.propTypes = {
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  orders: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default ProductCell;
